import React from 'react';

import { DynamicMediaItem } from '@uncinc/react-drupal-core';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import type { ActivityProps } from '..';

import './style.scss';

const ActivityOverlay: React.FC<ActivityProps> = (props) => {
  const { entity } = props;

  const taxonomy = entity.toJS();
  const name = taxonomy.name[0].value;
  const description = taxonomy.description[0].processed;
  const media = taxonomy.field_media_image[0];

  return (
    <div className="ActivityOverlay">
      <h2>{name}</h2>
      {media && (
        <div className="ActivityOverlay__media">
          <DynamicMediaItem
            // @ts-expect-error
            media={media}
            imageAspectRatio="3_2"
          />
        </div>
      )}
      {description && (
        <WysiwygField
          property="schema:text"
          className="ActivityOverlay__body"
          html={description}
        />
      )}
    </div>
  );
};

export default ActivityOverlay;
